import React from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { unitPrice } from "../../../../../../../../utils/product";
import { FormattedMessage } from "react-intl";

export default props =>{
    useStyles(cls);
    const { orderDetail } = props;

    return <div className={cls.OrderTotalDetail}>
        <div className={cls.PriceItem}>
            <div className={cls.Explain}>
                <span><FormattedMessage id="item" defaultMessage="Item" /><FormattedMessage id="total" defaultMessage="Total" /></span>
            </div>

            <div className={cls.Answer}>
                <span>{unitPrice(orderDetail?.paymentItemTotal)}</span>
            </div>
        </div>

        {
            orderDetail?.shippingPrice?.amount > 0 && <div className={cls.PriceItem}>
                <div className={cls.Explain}>
                    <span><FormattedMessage id="shipping_price" defaultMessage="Shipping Price" /></span>
                </div>

                <div className={cls.Answer}>
                    <span>{unitPrice(orderDetail.shippingPrice)}</span>
                </div>
            </div>
        }
        
        {
            orderDetail?.shippingInsurancePrice?.amount > 0 && <div className={cls.PriceItem}>
                <div className={cls.Explain}>
                    <span><FormattedMessage id="insurance" defaultMessage="Insurance" /></span>
                </div>

                <div className={cls.Answer}>
                    <span>{unitPrice(orderDetail.shippingInsurancePrice)}</span>
                </div>
            </div>
        }

        <div className={`${cls.PriceItem} ${cls.TotalPrice}`}>
            <div className={cls.Explain}>
                <span><FormattedMessage id="total" defaultMessage="Total" /></span>
            </div>

            <div className={cls.Answer}>
                <span>{unitPrice(orderDetail?.orderTotal)}</span>
            </div>
        </div>
    </div>
}